import React, { useEffect, useState, useContext } from "react";
import './Home.css'
import LoginContext from "../../Component/Context/LoginContext";
import logo from '../../Assest/LogoSingefin.png'
import users from '../../Assest/users.png'
import update from '../../Assest/update.png'
import exit from '../../Assest/exit.png'
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function Home() {

    const urlGetHome = urlApiServer + "homes?populate=*"
    const urlGetNews = urlApiServer + "postnews?populate=*"

    const [data, setData] = useState([]);
    const [dataNew, setDataNew] = useState([]);

    const { infoUser } = useContext(LoginContext)

    const loggedInUser = () => {
        Swal.fire({
            title: "Error",
            text: "Ya estas vinculado",
            icon: "error",
            allowOutsideClick: false
        });
    }

    const userOffline = () => {
        Swal.fire({
            title: "Error",
            text: "Inicia sesion primero",
            icon: "error",
            allowOutsideClick: false
        });
    }

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append('Content-Type', 'application/json');

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                const response = await fetch(urlGetHome, requestOptions);

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const homeResponse = await response.json();
                console.log('Información del inicio: ', homeResponse.data);
                setData(homeResponse.data); // Asumimos que los datos están en 'data'
            } catch (error) {
                if (error instanceof TypeError) {
                    console.log('Error de red:', error);
                } else {
                    console.log('Error al obtener los datos:', error);
                }
            }
        })();
    }, [urlGetHome]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetNews, requestOptions)
                    .then(response => response.json())
                    .then(newsResponse => {
                        console.log('info de las noticia: ', newsResponse.data);
                        setDataNew(newsResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }

        })();
    }, [urlGetNews]);

    if (!data.length || !data[0].imagen_portada) {
        return <p>Cargando...</p>;
    }

    return (
        <div className="containerHome">
            <div className="containerBannerHome">
                <div className="bannerHome">
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        autoplay={{ delay: 5000 }}
                        className="swiper-container"
                    >
                        {data[0].imagen_portada.map((img, index) => (
                            <SwiperSlide key={index}>
                                <div
                                    className="imageBannerHome"
                                    style={{
                                        backgroundImage: `url(${urlApiServerImage}${img.url})`,
                                        justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                            ? 'flex-end'
                                            : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                                ? 'center'
                                                : 'flex-start'

                                    }}
                                >
                                    {index === 0 && (
                                        <p className={'titleBannerHome'} >
                                            {data[0].texto_portada ? data[0].texto_portada : "..."}
                                        </p>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                    {infoUser.isLoged === true ? (
                        <div className="ContainerButton">
                            <div className="ButtonBanner" onClick={loggedInUser}>
                                <p className="titleButtonBanner">VINCULATE</p>
                            </div>
                        </div>
                    ) : (
                        <div className="ContainerButton">
                            <NavLink className="navLinks navLinkLegal" to="/Vinculacion">
                                <div className="ButtonBanner">
                                    <p className="titleButtonBanner">VINCULATE</p>
                                </div>
                            </NavLink>
                        </div>
                    )}
                </div>
                <div className="containerProgress">
                    <div className="progress">
                        <p className="textProgressing1">{data.length > 0 && data[0].afiliaciones ? data[0].afiliaciones : "..."}</p>
                        <p className="textProgressing2">BONOS ENTREGADOS</p>
                    </div>
                    <div className="separation">
                        <p className="lineSeparation">|</p>
                    </div>
                    <div className="progress">
                        <p className="textProgressing1">{data.length > 0 && data[0].anos_de_creacion ? data[0].anos_de_creacion : "..."}</p>
                        <p className="textProgressing2">AUXILIOS ENTREGADOS</p>
                    </div>
                    <div className="separation">
                        <p className="lineSeparation">|</p>
                    </div>
                    <div className="keepProgressing">
                        <p className="textkeepProgressing">{data.length > 0 && data[0].texto_progreso ? data[0].texto_progreso : "..."}</p>
                    </div>
                </div>
            </div >
            <div className="containerLinkingHome">
                <div className="containerIntroductorytextLinkingHome">
                    <p className="introductorytextLinkingHome">{data.length > 0 && data[0].texto_presentacion_vinculacion ? data[0].texto_presentacion_vinculacion : "..."}</p>
                </div>
                <div className="containerCardLinkingHome">
                    <div className="cardLinkingsHome">
                        <div className="containerIconCardLinkingsHome">
                            <img src={users} alt='users' className="iconCardLinkingsHome" />
                        </div>
                        <p className="textLinkingsHome">{data.length > 0 && data[0].texto_cajon_vinculacion ? data[0].texto_cajon_vinculacion : "..."}</p>
                        {infoUser.isLoged === true ? (
                            <div className="ButtonLinkingHome buttonColor1" onClick={loggedInUser}>
                                <p className="textButtonLinkingHome">VINCULATE</p>
                            </div>
                        ) : (
                            <NavLink className="navLinks" to="/Vinculacion">
                                <div className="ButtonLinkingHome buttonColor1">
                                    <p className="textButtonLinkingHome">VINCULATE</p>
                                </div>
                            </NavLink >
                        )}
                    </div>
                    <div className="cardLinkingsHome">
                        <div className="containerIconCardLinkingsHome">
                            <img src={update} alt='update' className="iconCardLinkingsHome" />
                        </div>
                        <p className="textLinkingsHome">{data.length > 0 && data[0].texto_cajon_actualizacion ? data[0].texto_cajon_actualizacion : "..."}</p>
                        {infoUser.isLoged === false ? (
                            <div className="ButtonLinkingHome buttonColor2" onClick={userOffline}>
                                <p className="textButtonLinkingHome">ACTUALIZAR</p>
                            </div>

                        ) : (
                            <NavLink className="navLinks navLinkHome" to="/Actualizar">
                                <div className="ButtonLinkingHome buttonColor2">
                                    <p className="textButtonLinkingHome">ACTUALIZAR</p>
                                </div>
                            </ NavLink >
                        )}
                    </div>
                    <div className="cardLinkingsHome">
                        <div className="containerIconCardLinkingsHome">
                            <img src={exit} alt='exit' className="iconCardLinkingshome" />
                        </div>
                        <p className="textLinkingsHome">{data.length > 0 && data[0].texto_cajon_desvinculacion ? data[0].texto_cajon_desvinculacion : "..."}</p>
                        {infoUser.isLoged === false ? (
                            <div className="ButtonLinkingHome buttonColor3" onClick={userOffline}>
                                <p className="textButtonLinkingHome">DESVINCULAR</p>
                            </div>

                        ) : (
                            <NavLink className="navLinks navLinkHome" to="/Desvincular">
                                <div className="ButtonLinkingHome buttonColor3">
                                    <p className="textButtonLinkingHome">DESVINCULAR</p>
                                </div>
                            </NavLink >
                        )}
                    </div>
                </div >
            </div >
            <div className="containerSchedule">
                <div className="containerTextSchedule">
                    <p className="titleScheduleHome">{data.length > 0 && data[0].titulo_agenda ? data[0].titulo_agenda : "..."}</p>
                    <p className="textScheduleHome">{data.length > 0 && data[0].texto_agenda ? data[0].texto_agenda : "..."}</p>
                    <NavLink className="navLinks" to="/Agendar">
                        <div className="buttonScheduleHome">
                            <p className="textButtonScheduleHome">AGENDAR</p>
                        </div>
                    </NavLink>
                </div>
                <div className="containerImageScheaduleHome">
                    <img
                        src={
                            data.length > 0 && data[0].imagen_agenda?.url
                                ? urlApiServerImage + data[0].imagen_agenda.url
                                : "fallback-image.jpg" // Imagen de respaldo
                        }
                        alt="Contactanos"
                        className="imageContact"
                    />
                </div>
            </div>
            <div
                className="containerPQRSHome"
                style={{
                    backgroundImage: data.length > 0 && data[0].imagen_pqrs?.url
                        ? `url(${urlApiServerImage}${data[0].imagen_pqrs.url})`
                        : "url('../../Assest/temporary/PQRSSection.png')", // Imagen de respaldo
                }}
            >
                <p className="titlePQRSHome">{data.length > 0 && data[0].titulo_pqrs ? data[0].titulo_pqrs : "..."}</p>
                <p className="textPQRSHome">{data.length > 0 && data[0].texto_pqrs ? data[0].texto_pqrs : "..."}</p>
                <NavLink className="navLinks" to="/PQRS">
                    <div className="buttonPQRSHome">
                        <p className="textButtonPQRSHome">ENVIAR PQR</p>
                    </div>
                </NavLink>
            </div>
            <div className="containerGeneralCommunicationsHome">
                <p className="titleCommunicationsHome">COMUNICACIONES</p>
                <div className="containerCommunicationsHome">
                    <div className="containerImageNew">
                        <img
                            src={
                                dataNew.length > 0 &&
                                    dataNew[dataNew.length - 1].imagen_noticia[0]?.url
                                    ? urlApiServerImage + dataNew[dataNew.length - 1].imagen_noticia[0].url
                                    : "fallback-image.jpg" // Imagen de respaldo
                            }
                            alt="News"
                            className="imageNewHome"
                        />
                    </div>
                    <div className="containerInformationCommunicationsHome">
                        <p className="titleNewsCommunicationsHome">
                            {dataNew.length > 0 && dataNew[dataNew.length - 1].titulo_noticia
                                ? dataNew[dataNew.length - 1].titulo_noticia
                                : "..."}
                        </p>
                        <p className="descriptionNewsComunicationHome">
                            {dataNew.length > 0 && dataNew[dataNew.length - 1].texto_noticia
                                ? dataNew[dataNew.length - 1].texto_noticia
                                : "..."}
                        </p>
                        <NavLink className="navLinks" to="/Comunicaciones">
                            <div className="buttonComunicationHome">
                                <p className="textButtonComunicationHome">VER COMUNICACIONES</p>
                            </div>
                        </NavLink>
                    </div>
                </div>
            </div>
            <div className="containerGeneralContact">
                <div className="containerTextContact">
                    <p className="titleContactHome">{data.length > 0 && data[0].titulo_contactanos ? data[0].titulo_contactanos : "..."}</p>
                    <p className="textContactHome">{data.length > 0 && data[0].texto_contactanos ? data[0].texto_contactanos : "..."}</p>
                    <NavLink className="navLinks" to="/Contactanos">
                        <div className="buttonContactHome">
                            <p className="textButtonContactHome">CONTACTAR</p>
                        </div>
                    </NavLink>

                </div>
                <div className="containerImageContactHome">
                    <img
                        src={
                            data.length > 0 && data[0].imagen_contactanos?.url
                                ? urlApiServerImage + data[0].imagen_contactanos.url
                                : "fallback-image.jpg" // Imagen de respaldo
                        }
                        alt='Contactanos'
                        className="imageContactHome"
                    />
                </div>
            </div>
        </div >
    )
}

export default Home
